import React, { useState } from 'react';
import { useUpdateBulk } from '../hooks/useObjets';

interface BulkUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedIds: string[];
}

const BulkUpdateModal: React.FC<BulkUpdateModalProps> = ({ isOpen, onClose, selectedIds }) => {
  const updateBulkMutation = useUpdateBulk();
  const [field, setField] = useState<'etat' | 'besoinAchat'>('etat');
  const [etat, setEtat] = useState<string>('');
  const [besoinAchat, setBesoinAchat] = useState<boolean>(false);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const updates: any = {};
    if (field === 'etat' && etat) {
      updates.etat = etat;
    } else if (field === 'besoinAchat') {
      updates.besoinAchat = besoinAchat;
    }

    try {
      await updateBulkMutation.mutateAsync({
        objetIds: selectedIds,
        updates,
      });
      alert(`${selectedIds.length} objet(s) modifié(s) avec succès !`);
      onClose();
    } catch (error: any) {
      console.error('Erreur lors de la modification en masse:', error);
      alert(`Erreur: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={onClose} />

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <form onSubmit={handleSubmit}>
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  ✏️ Modifier {selectedIds.length} objet(s)
                </h3>
                <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-500">
                  <span className="text-2xl">&times;</span>
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Champ à modifier
                  </label>
                  <select
                    value={field}
                    onChange={(e) => setField(e.target.value as 'etat' | 'besoinAchat')}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="etat">État</option>
                    <option value="besoinAchat">Besoin d'achat</option>
                  </select>
                </div>

                {field === 'etat' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nouvel état
                    </label>
                    <select
                      value={etat}
                      onChange={(e) => setEtat(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    >
                      <option value="">Sélectionner un état</option>
                      <option value="bon">Bon</option>
                      <option value="à réparer">À réparer</option>
                      <option value="incomplet">Incomplet</option>
                      <option value="neuf">Neuf</option>
                      <option value="usé">Usé</option>
                      <option value="hs">HS</option>
                    </select>
                  </div>
                )}

                {field === 'besoinAchat' && (
                  <div>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={besoinAchat}
                        onChange={(e) => setBesoinAchat(e.target.checked)}
                        className="form-checkbox text-blue-600"
                      />
                      <span className="text-sm font-medium text-gray-700">
                        Besoin d'achat
                      </span>
                    </label>
                  </div>
                )}

                <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
                  <p className="text-sm text-yellow-800">
                    ⚠️ Cette action modifiera les {selectedIds.length} objets sélectionnés.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                disabled={updateBulkMutation.isPending}
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 disabled:opacity-50 sm:ml-3 sm:w-auto sm:text-sm"
              >
                {updateBulkMutation.isPending ? 'Modification...' : 'Modifier'}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Annuler
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BulkUpdateModal;

